module.exports = __webpack_public_path__ + "img/image-poll.1ca22731.png";